// @ts-strict-ignore
import { useMutation } from '@tanstack/react-query'
import { logSentryError } from '@node-space/utils'
import { useWebhooksRequestConfig } from 'hooks/useWebhooksBaseUrl'
import {
  deleteNotificationDestination,
  DeleteNotificationDestinationRequest,
} from 'services/WebHooksService'
import { BaseErrorResponse } from 'types/beneficiaries'

export const useDeleteNotificationDestinationMutation = () => {
  const requestConfig = useWebhooksRequestConfig()
  return useMutation({
    mutationFn: (data: Omit<DeleteNotificationDestinationRequest, keyof typeof requestConfig>) =>
      deleteNotificationDestination({ ...data, ...requestConfig }),
    onError(error: BaseErrorResponse, data) {
      logSentryError('Error from useDeleteWebhookDestinationMutation', error, data)
    },
  })
}
